// extracted by mini-css-extract-plugin
module.exports = {"CardObserver":"card-observer_CardObserver__TZqXi"};